import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { PaymentReconciliationModel } from '../model/PaymentReconciliationModel';
import { OnlinePaymentTransactionStatusModel } from '../model/OnlinePaymentTransactionStatusModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentTransactionViewModel } from '../model/PaymentTransactionViewModel';

@Injectable({
  providedIn: 'root'
})
export class PaymentReconciliationService {
  

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchPaymentReconciliationByFilter(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<PaymentReconciliationModel>>(
      ApiUrls.paymentReconSearch + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }

  fetchPaymentReconciliationByTransactionId(transactionId: string) {
    return this.httpClient.get<OnlinePaymentTransactionStatusModel>(
      ApiUrls.paymentReconByTransaction.replace('{transactionId}', transactionId.toString()));
  }

  fetchPendingTransactionList() {
    return this.httpClient.get<PaymentTransactionViewModel[]>(
      ApiUrls.pendingTransactions);
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
